const MODE = {
  CREATE: 'CREATE_INTERACTION',
  EDIT: 'EDIT_INTERACTION',
  LIST: 'LIST_INTERACTION'
};

export const NODE_EDIT = {
  MODE
};
